import { render } from "./CompanyTopNavbar.vue?vue&type=template&id=27703c20"
import script from "./CompanyTopNavbar.vue?vue&type=script&lang=js"
export * from "./CompanyTopNavbar.vue?vue&type=script&lang=js"

import "./CompanyTopNavbar.vue?vue&type=style&index=0&id=27703c20&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__